import Vue from 'vue';

export default Vue.component('i-frame', {
  data: function() {
    return {
      timeout: null,
      lastResize: 0
    };
  },
  render(h) {
    return h('iframe', {
      domProps: { scrolling: 'no' },
      ref: 'iframe',
      on: { load: this.renderChildren }
    });
  },
  beforeUpdate() {
    // freezing to prevent unnessessary Reactifiation of vNodes
    this.iApp.children = Object.freeze(this.$slots.default);
  },
  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
  methods: {
    resize(iframeEl) {
      let self = this;
      let o = iframeEl.style.height;
      let n = (iframeEl.contentWindow.document.body.scrollHeight) + 'px';
      iframeEl.style.height = n;
      clearTimeout(this.timeout);
      this.timeout = null;
      if (o !== n) {
        const diff = parseInt(n, 10) - parseInt(o, 10);
        if (diff !== this.lastResize) {
          console.log('resize', o, n);
          this.timeout = setTimeout(() => { self.resize(iframeEl); }, 1000);
          this.lastResize = diff;
        }
      }
    },
    renderChildren() {
      const children = this.$slots.default;
      const body = this.$el.contentDocument.body;
      const el = document.createElement('DIV'); // we will mount or nested app to this element
      body.appendChild(el);
      let iframeEl = this.$refs.iframe;
      let self = this;

      const iApp = new Vue({
        name: 'iApp',
        // freezing to prevent unnessessary Reactifiation of vNodes
        data: { children: Object.freeze(children) },
        render(h) {
          iframeEl.style.height = '100px';
          this.lastResize = 0;

          this.$nextTick(() => {
            if ((iframeEl) && (iframeEl.contentWindow) && (iframeEl.contentWindow.document)) {
              iframeEl.style.height = (iframeEl.contentWindow.document.body.scrollHeight + 20) + 'px';
              self.timeout = setTimeout(() => {
                self.resize(iframeEl);
              }, 1000);
            }
          });
          return h('div', this.children);
        }
      });

      iApp.$mount(el); // mount into iframe

      this.iApp = iApp; // cache instance for later updates
    }
  }
});
